import { receiptUIUrl } from '../../urls'

export const buildReceiptUrl = (companyIndex, orderPublicId) =>
	`${receiptUIUrl}/receipt?companyIndex=${companyIndex}&orderPublicId=${orderPublicId}`
